import { Button, Group, Text } from "@mantine/core"
import { ConvertIcon } from "../../../icons/x-symbol-svgrepo-com"
import { useContext, useState } from "react";
import IdeaContext from "../IdeaContext";
import { saveIdea } from "../../../Api";
import { useAuth0 } from "@auth0/auth0-react";
import { showNotification } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons";
import { LIGHT_GREY_BG } from "../../../constants/colors";
import { ArchiveIdeaModal } from "../idea-module/ArchiveIdeaModal";
import {useFields} from "../../../hooks/useFields";

const GeneratedBar = () => {
  const auth0 = useAuth0()
  const [archiveModalOpened, setArchiveModalOpened] = useState(false);

  const { ideaStatuses } = useFields();

  const defaultIdeaStatus = ideaStatuses?.find((status: any)=> status.isDefault)

  const {
    idea, fetchData
  } = useContext(IdeaContext);


  const onSelectSave = async () => {

    setTimeout(() => {
      showNotification({
        title: "This is now an active idea",
        color: "teal",
        message: ``,
        icon: <IconCheck size="1.1rem" />,
        autoClose: 1400,
      });
    }, 2000);
    
    if (idea) {
      const ideaObj: any = {
        id: idea._id,
        state: 'active',
        status: defaultIdeaStatus?.label
      };
      if(idea?.componentObj?.ownerId){
        ideaObj.ownerId = idea?.componentObj?.ownerId
      }
      const response = await saveIdea(ideaObj, auth0)
        .then(async ()=>{
          await fetchData()
          
        })
            
      return response
    }
  };

  return (
    <>
      <Group mb={20} position='apart' p="5px" mx="20px" style={{borderRadius: 4, backgroundColor: "#9CEAC2"}}>
        <Group spacing={8}>

          <Text fz={12} lineClamp={2} w={700}>
          This idea was automatically generated by Bagel AI and is currently in read-only mode.
           To save and edit it, click the "Convert to idea" button.
          </Text>

        </Group>
        <Group spacing={8}>
          <Button
            h={32}
            w={160}
            variant="outline" 
            leftIcon={<ConvertIcon />}
            onClick={() => {
              onSelectSave()
            }}
            styles={(theme) => ({
              root: {
                height: "32px",
                backgroundColor: "white",
                border: `1px solid #B0B0B0`,
                fontWeight: 400,
                padding: "0px 5px",
                margin: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                "&:hover": {
                  backgroundColor: theme.fn.darken(LIGHT_GREY_BG, 0.05),
                },
              },
              loader: {
                position: "absolute",
                color: theme.white,
              },
              leftIcon: {
                marginRight: 15,
              },
            })}
          >
            <Text color="#5C5CEB" fz={12}>
              Convert to idea
            </Text>
          </Button>

          <Button
            h={32}
            w={160}
            variant="outline"
            leftIcon={<IconX size={16} />}
            onClick={() => setArchiveModalOpened(true)}
            styles={(theme) => ({
              root: {
                height: "32px",
                backgroundColor: "white",
                border: `1px solid #B0B0B0`,
                fontWeight: 400,
                padding: "0px 5px",
                margin: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                "&:hover": {
                  backgroundColor: theme.fn.darken(LIGHT_GREY_BG, 0.05),
                },
              },
              leftIcon: {
                marginRight: 15,
              },
            })}
          >
            <Text color="#DC3545" fz={12}>
              Not a good fit
            </Text>
          </Button>
        </Group>
      </Group>

      <ArchiveIdeaModal
        opened={archiveModalOpened}
        onClose={() => setArchiveModalOpened(false)}
        idea={idea}
        onSuccess={() => {
          fetchData();
        }}
      />
    </>
  )
}

export default GeneratedBar